import { c as _c } from "react/compiler-runtime";
import { SvgChevrondown } from '@common/icon';
import { cn } from '@core/utils';
import { useClosableOnClickOpeningState } from '@/hooks/useClosableOnClickOpeningState';
import { useSubscribedState } from '@/hooks/useSubscribedState';
import { Option, type OptionProps, type ValidOptionValue } from '../Option/Option';
import { Input, type InputProps } from './Input';
import { InputWrap, type InputWrapProps } from './InputWrap';
export interface SelectboxProps<TValidOptionValue extends ValidOptionValue = ValidOptionValue, TMultiple extends boolean = false, TCancelable extends boolean = true> extends Omit<InputProps, 'style' | 'className' | 'onChange' | 'value' | 'multiple' | 'type' | 'children'>, Pick<InputWrapProps, 'reversed' | 'className' | 'style' | 'label' | 'validationMessage' | 'shape' | 'size'>, Pick<OptionProps<TValidOptionValue, TMultiple, TCancelable>, 'options' | 'float' | 'value' | 'multiple' | 'cancelable' | 'onChange'> {
  children?: React.ReactNode;
}
export const Selectbox = t0 => {
  const $ = _c(42);
  const {
    children,
    reversed,
    className,
    style,
    label,
    validationMessage,
    size,
    shape,
    options,
    float,
    onChange,
    value,
    multiple,
    cancelable,
    onClick,
    ...restInputProps
  } = t0;
  const [selectedValue, setSelectedValue] = useSubscribedState(value);
  const {
    disabled,
    readOnly,
    required
  } = restInputProps;
  let t1;
  if ($[0] !== multiple || $[1] !== options || $[2] !== selectedValue) {
    const selectedOption = multiple ? options?.filter(t2 => {
      const {
        value: value_0
      } = t2;
      return (selectedValue as TValidOptionValue[])?.includes(value_0);
    }) : options?.find(t3 => {
      const {
        value: value_1
      } = t3;
      return value_1 === selectedValue;
    });
    t1 = Array.isArray(selectedOption) ? selectedOption.map(_temp).join(", ") : selectedOption?.label;
    $[0] = multiple;
    $[1] = options;
    $[2] = selectedValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const displayedValue = t1;
  const {
    openingState: t2,
    setClosableOnClick
  } = useClosableOnClickOpeningState();
  const [opened, setOpened] = t2;
  const setOpenedIfEnabled = value_2 => {
    if (readOnly) {
      return;
    }
    setOpened(value_2);
  };
  const decoration = children ?? <SvgChevrondown className={cn("size-20 cursor-pointer text-Gray-600 transition-transform duration-200 ease-in-out", opened && "rotate-180", disabled && "cursor-default")} />;
  let t3;
  let t4;
  if ($[4] !== setClosableOnClick) {
    t3 = () => setClosableOnClick(false);
    t4 = () => setClosableOnClick(true);
    $[4] = setClosableOnClick;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onClick || $[8] !== setOpenedIfEnabled) {
    t5 = e => {
      onClick?.(e);
      setOpenedIfEnabled(_temp2);
    };
    $[7] = onClick;
    $[8] = setOpenedIfEnabled;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== displayedValue || $[11] !== restInputProps || $[12] !== t5) {
    t6 = <Input {...restInputProps} type="button" value={displayedValue} onClick={t5} />;
    $[10] = displayedValue;
    $[11] = restInputProps;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== decoration) {
    t7 = decoration ? <div className="flex items-center whitespace-nowrap font-700 text-Gray-700">{decoration}</div> : null;
    $[14] = decoration;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== onChange || $[17] !== setOpenedIfEnabled || $[18] !== setSelectedValue) {
    t8 = e_0 => {
      onChange?.(e_0);
      setSelectedValue(e_0.value);
      setOpenedIfEnabled(false);
    };
    $[16] = onChange;
    $[17] = setOpenedIfEnabled;
    $[18] = setSelectedValue;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== cancelable || $[21] !== float || $[22] !== multiple || $[23] !== opened || $[24] !== options || $[25] !== selectedValue || $[26] !== t8) {
    t9 = <Option cancelable={cancelable} float={float} multiple={multiple} opened={opened} options={options} value={selectedValue} onChange={t8} />;
    $[20] = cancelable;
    $[21] = float;
    $[22] = multiple;
    $[23] = opened;
    $[24] = options;
    $[25] = selectedValue;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== className || $[29] !== label || $[30] !== required || $[31] !== reversed || $[32] !== shape || $[33] !== size || $[34] !== style || $[35] !== t3 || $[36] !== t4 || $[37] !== t6 || $[38] !== t7 || $[39] !== t9 || $[40] !== validationMessage) {
    t10 = <InputWrap className={className} label={label} required={required} reversed={reversed} shape={shape} size={size} style={style} validationMessage={validationMessage} onMouseEnter={t3} onMouseLeave={t4}>{t6}{t7}{t9}</InputWrap>;
    $[28] = className;
    $[29] = label;
    $[30] = required;
    $[31] = reversed;
    $[32] = shape;
    $[33] = size;
    $[34] = style;
    $[35] = t3;
    $[36] = t4;
    $[37] = t6;
    $[38] = t7;
    $[39] = t9;
    $[40] = validationMessage;
    $[41] = t10;
  } else {
    t10 = $[41];
  }
  return t10;
};
function _temp(t0) {
  const {
    label: label_0
  } = t0;
  return label_0;
}
function _temp2(prev) {
  return !prev;
}